<template>
  <div class="d-flex justify-center">
    <v-card
      :width="mobile ? '80%' : '55%'"
      max-height="78vh"
      elevation="4"
      class="d-flex flex-column"
    >
        <v-card-title class="text-h5 text-center font-weight-bold py-4">
        Relatório de Estoque
        </v-card-title>

        <v-card-subtitle class="text-center mb-4">
        Selecione os filtros para gerar o relatório
        </v-card-subtitle>

        <v-divider />

        <v-card-text>
            <v-form ref="form">
                <v-row class="mt-2" justify="center" dense>
                    <v-col cols="12" md="5">
                        <BaseAutoComplete
                            v-model="stock.stockId"
                            store-module="stock"
                            items-state="lstStock"
                            :item-title="item => `${item.stockId} - ${item.stockName}`"
                            item-value="stockId"
                            action="search"
                            label="Estoque"
                            density="comfortable"
                            prepend-inner-icon="mdi-package-variant"
                            :rules="[v => !!v || 'Campo obrigatório']"
                        />
                    </v-col>
        
                    <v-col cols="12" md="5">
                        <BaseAutoComplete
                            v-model="product.productId"
                            store-module="product"
                            items-state="lstProduct"
                            :item-title="item => `${item.productId} - ${item.productName}`"
                            item-value="stockproductIdId"
                            action="search"
                            label="Produto"
                            density="comfortable"
                            prepend-inner-icon="mdi-sprout"
                        />
                    </v-col>
                </v-row>
        
                <v-row class="mt-6 mb-4" justify="center">
                    <v-btn
                        color="primary"
                        rounded
                        @click="generateRelat()"
                    >
                        Gerar relatório
                    </v-btn>
                </v-row>
            </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { useDisplay } from 'vuetify'
import BaseAutoComplete from '@/components/BaseAutoComplete.vue';

export default {
    setup () {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data: () => ({
    }),
    components: {
        BaseAutoComplete
    },
    computed: {
        stock: {
            get() {
                return this.$store.state.stock
            },
        },
        product: {
            get() {
                return this.$store.state.product
            }
        }
    },
    methods: {
        async generateRelat() {
            const { valid } = await this.$refs.form.validate()

            if (!valid) return

            await this.$store.dispatch('relats/downloadStockReport', { 
                stockId: this.stock.stockId, 
                productId: this.product.productId 
            })
        }
    },
    async mounted() {
        this.stock.stockId = null
        this.product.productId = null
    }
}
</script>

<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>